import React, { useState, useEffect } from "react";
import { Form, Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import cross from "../../assets/images/icon/cross.svg";

function UpdationModal({
  show,
  handleUpdationClose,
  handleUpdation,
  message,
  user_id,
  initialDOB,
}) {
  const [dob, setDob] = useState(null);
  const [formData, setFormData] = useState(null);

  useEffect(() => {
    if (initialDOB) {
      const initialDate = new Date(initialDOB);
      setDob(initialDate);
    }
  }, [initialDOB]);

  const handleChange = date => {
    setDob(date); // Update DOB state with selected date
  };

  useEffect(() => {
    if (show) {
      const timeout = setTimeout(() => {
        const modalBackdrop = document.querySelector(".modal-backdrop");
        if (modalBackdrop) {
          modalBackdrop.classList.add("edit-cksisjs");
        }
      }, 10); // Adjust the delay as necessary

      return () => clearTimeout(timeout);
    }
  }, [show]);

  return (
    <div className="edit-modal">
      <Modal
        show={show}
        onHide={handleUpdationClose}
        className="edit-modal-card"
      >
        <Modal.Body>
          <div className="filters-cards-cross">
            <div className="filter-content">
              <h4>{message}</h4>
            </div>
            <div className="filter-content cross" onClick={handleUpdationClose}>
              <img src={cross} alt="" />
            </div>
          </div>
          <div className="bordertops"></div>
          <Form className="form-modal">
            <div className="form-group">
              <div className="row">
                <div
                  id="address-group"
                  className="form-group form-group-lg col-sm-12"
                >
                  <label className="float-label form-label">Enter DOB:</label>
                  <DatePicker
                    selected={dob}
                    onChange={handleChange}
                    className="form-control"
                    dateFormat="yyyy-MM-dd"
                    placeholderText="Select Date"
                    maxDate={new Date()}
                    title={`Please enter dob`}
                  />
                </div>
              </div>
            </div>

            <div className="serach-btn modal-action-btn text-center mt-4 d-flex gap-3">
              <button
                className="btn btn-primary reset"
                type="button"
                onClick={handleUpdationClose}
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={() => handleUpdation(user_id, dob, formData)}
                className="btn btn-primary search"
              >
                Submit
              </button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default UpdationModal;
